module.exports = __webpack_public_path__ + "static/media/logo-onoiwa-mx-ori.74ecf9d1.png";